import styles from "../CreditLogs/CreditLogsPopup.module.scss";
import closeIcon from "../../../../../assets/images/icons/close-grey.svg";
import MainTitle from "../../../../../components/ui/MainTitle/MainTitle";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetUserSubscriptionsCreditLogsQuery } from "../../../../../api/queries/useUserSubscriptionQuery";
import { Table, TableProps } from "antd";
import {
  IUserSubscriptionCreditLog,
  UserSubscriptionCreditLogType,
} from "../../../../../models/UserSubscription";
import dayjs from "dayjs";
import dots from "../../../../../assets/images/icons/dots.svg";
import downloadIcon from "../../../../../assets/images/icons/download.svg";

type ColumnsType<T> = TableProps<T>["columns"];

interface CreditLogsPopupProps {
  closePopup: () => void;
  userSubscriptionId: string;
}

const CreditLogsPopup: React.FC<CreditLogsPopupProps> = ({ closePopup, userSubscriptionId }) => {
  const { t } = useTranslation();

  const [tableParams, setTableParams] = useState<{ currentPage: number; pageSize: number }>({
    currentPage: 1,
    pageSize: 10,
  });

  const { data = { items: [], total: 0 }, isLoading } = useGetUserSubscriptionsCreditLogsQuery(
    userSubscriptionId,
    tableParams
  );
  const totalCount = useMemo(() => {
    if (!data) return 0;
    return data.total;
  }, [data]);

  const handleTableChange: TableProps<IUserSubscriptionCreditLog>["onChange"] = (pagination) => {
    setTableParams({
      currentPage: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
    });
  };

  const columns: ColumnsType<IUserSubscriptionCreditLog> = [
    {
      title: t("Date"),
      render: (data: IUserSubscriptionCreditLog) => {
        return `${dayjs(data.createdAt).format("DD/MM/YYYY")}`;
      },
    },
    {
      title: t("Action"),
      render: (data: IUserSubscriptionCreditLog) => {
        return data.creditsActionValue <= 0
          ? data.creditsActionValue
          : `+${data.creditsActionValue}`;
      },
    },
    {
      title: t("UpdatedCredits"),
      render: (data: IUserSubscriptionCreditLog) => {
        return data.creditsAfterAction;
      },
    },
    {
      title: t("Type"),
      render: (data: IUserSubscriptionCreditLog) => {
        return t(UserSubscriptionCreditLogType[data.type]);
      },
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <button onClick={closePopup} className={styles.closeBtn}>
          <img src={closeIcon} alt="close" />
        </button>
        <MainTitle titleSize={20} text={t("CreditLogs")} />

        <Table
          className={"table"}
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={data.items}
          pagination={{ ...tableParams, total: totalCount }}
          loading={isLoading}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default CreditLogsPopup;
